import { de, enGB, fr, ptBR, ru, zhCN } from 'date-fns/locale';

import { useAppLang } from './useAppLang';

const LangToLocaleNap = {
  de,
  en: enGB,
  fr,
  'pt-BR': ptBR,
  ru,
  'zh-CN': zhCN,
} as const;

export function useUserLocale() {
  const { appLang } = useAppLang();
  const userLocale = LangToLocaleNap[appLang];

  return { userLocale };
}
